<template>
  <div class="toasts_container">
    <!-- all existed notification -->
    <transition-group
      name="float"
      tag="p"
      appear
    >
      <div
        v-for="toast in toasts"
        :key="toast"
        :class="['my_toast', toast.status]"
      >
        <div class="icon">
          <img :src="`/img/${toast.status}_check.svg`">
        </div>

        <div class="text">
          <p class="toast_title">
            Ошибка при обработке запроса
          </p>

          <p class="toast_desc">
            {{ toast.message }}
          </p>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: "Toast",

  computed: {
    ...mapState(['toasts'])
  },

  methods: {
  }
}
</script>
